import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  emailValidatorList,
  createSecondFieldValidator,
} from '@shared/common/data/inputs';
import {
  EMAIL_ERROR,
  REQUIRED_ERROR,
  PASSWORD_MATCH_ERROR,
} from '@shared/jp/data/inputs';
import { Logger } from '@shared/common/logger';
import { EButtonColor } from '@studiobuki/web-core/lib/button';
import { EInputTheme } from '@studiobuki/web-core/lib/input';
import type { ISignUpData } from '../../auth-page.interfaces';

const log = new Logger('FormSignInComponent');

@Component({
  selector: 'app-form-sign-up',
  templateUrl: './form-sign-up.component.html',
  styleUrls: ['./form-sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSignUpComponent {
  @Output() signUpButtonClick = new EventEmitter<ISignUpData>();

  @Output() signInButtonClick = new EventEmitter<void>();

  public readonly formGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', emailValidatorList),
    emailReceive: new UntypedFormControl(true),
    password: new UntypedFormControl('', [Validators.required]),
    password2: new UntypedFormControl('', [
      createSecondFieldValidator('password'),
    ]),
  });

  public readonly EButtonColor = EButtonColor;

  public readonly EInputTheme = EInputTheme;

  public readonly EMAIL_ERROR = EMAIL_ERROR;

  public readonly REQUIRED_ERROR = REQUIRED_ERROR;

  public readonly PASSWORD_MATCH_ERROR = PASSWORD_MATCH_ERROR;

  // constructor() {}

  public onSignUpButtonClick() {
    const data = this.formGroup.value as ISignUpData;

    log.info('onSignUpButtonClick', data);
    this.signUpButtonClick.emit(data);
  }

  public onSignInButtonClick() {
    log.info('onSignInButtonClick');
    this.signInButtonClick.emit();
  }
}
